import * as api from './api';
import * as types from './mutations';
import { Loading } from 'element-ui';

let loadingService = undefined;

const startLoadingService = () => {
    loadingService = Loading.service({
        fullscreen: true,
        lock: true,
        text: `Registration in progress - please wait a moment...`
    });
};

const stopLoadingService = () => {
    loadingService.close();
};

const state = {
    events: [],
    eventSessions: [],
    eventSpeakers: [],
    eventFaqs: [],
    registrationSuccess: false,
    isProcessing: false,
    mcd: {
        data: undefined,
        completed: false,
        message: '',
        form: '',
    },
};

const getters = {
};

const mutations = {
    [types.UPDATE_EVENTS](state, events) {
        state.events = events;
    },

    [types.UPDATE_EVENT_SESSIONS](state, eventSessions) {
        state.eventSessions = eventSessions;
    },

    [types.UPDATE_EVENT_SPEAKERS](state, eventSpeakers) {
        state.eventSpeakers = eventSpeakers;
    },
    
    [types.UPDATE_EVENT_FAQS](state, eventFaqs) {
        state.eventFaqs = eventFaqs;
    },

    [types.SET_REGISTRATION_SUCCESS_STATE](state, isSuccess) {
        state.registrationSuccess = isSuccess;
    },

    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    },

    [types.SET_CURRENT_MCD](state, mcd) {
        state.mcd.data = mcd;
    },

    [types.SET_REGISTER_STATE](state, payload) {
        state.mcd.completed = payload.completed;
        state.mcd.message = payload.message;
    },

    [types.SET_MCD_REGO_FORM](state, form) {
        state.mcd.form = form;
    }
};

const actions = {
    isDownloadable({}, {event_id, email, session}) {
        return new Promise((resolve, reject) => {
            axios.post(api.isDownloadable, { event_id, email, session })
                .then(({data}) => {
                    resolve(data)
                })
                .catch(({response}) => reject(response));
        });
    },
    
    getSessions({commit}, eventId) {
        return new Promise((resolve, reject) => {
            axios.get(api.getEventSessions(eventId))
                .then(({data}) => {
                    commit(types.UPDATE_EVENT_SESSIONS, data.sessions);
                    resolve(data.data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getSpeakers({commit}, eventId) {
        return new Promise((resolve, reject) => {
            axios.get(api.getEventSpeakers(eventId))
                .then(({data}) => {
                    commit(types.UPDATE_EVENT_SPEAKERS, data.speakers);
                    resolve(data.data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getEventsListing({commit, state}) {
        if (state.events.length) return;

        commit(types.SET_PROCESSING_STATE, true);

        return new Promise((resolve, reject) => {
            axios.get(api.getEventsListing)
                .then(({data}) => {
                    commit(types.UPDATE_EVENTS, data.data);
                    resolve(data.data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getFaqs({commit}, eventId) {
        return new Promise((resolve, reject) => {
            axios.get(api.getEventFaqs(eventId))
                .then(({data}) => {
                    commit(types.UPDATE_EVENT_FAQS, data.faqs);
                    resolve(data.data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getMcdEvent({commit, state}, eventHashedId) {
        if (state.mcd.data) return;

        commit(types.SET_PROCESSING_STATE, true);

        return new Promise((resolve, reject) => {
            axios.get(api.getMcdEvent(eventHashedId))
                .then(({data}) => {
                    commit(types.SET_CURRENT_MCD, data.mcd.data);
                    resolve(data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    mcdRegisterFree(_, {payload, eventId}) {
        return new Promise((resolve, reject) => {
            startLoadingService();

            axios.post(api.mcdRegisterFree(eventId), {...payload})
                .then(({data}) => resolve(data.attendee.data))
                .catch(({response}) => reject(response))
                .done(_ => stopLoadingService());
        });
    },

    mcdRegister(_, {payload, eventId, endpoint}) {
        return new Promise((resolve, reject) => {
            startLoadingService();

            axios.post(api[endpoint](eventId), {...payload})
                .then(({data}) => {
                    resolve(data)
                })
                .catch(({response}) => reject(response))
                .done(_ => stopLoadingService());
        });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
